import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { ConfirmModal } from '../_services/confirm-modal.factory';

class OperatorSettingsFcfsCtrl implements ng.IController {
    private fcfsEnabled: boolean;
    private settings: TsoFcfsSettingsDto;
    private loadingSettings: boolean = true;
    private authenticatedUser: LoginResult;
    private togglingFcfs: boolean = false;
    public provideExternalFcfsUrl: boolean = false;

    public confirmDialogTitle: string;
    public confirmDialogText: string;
    private currentFcfsPortalUrl: string;

    private enableSetRestrictions: boolean;
    private togglingSetRestrictions: boolean;

    private enabledSettings: PossibleSettings[];

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private $uibModal: any,
        private confirmModal: ConfirmModal
    ) {}

    $onInit(): void {
        this.loadingSettings = true;
        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                this.authenticatedUser = loginResult;

                this.TransmissionSystemOperator.queryFcfsSettings(
                    { id: this.authenticatedUser.referenceId },
                    (res: TsoFcfsSettingsDto) => {
                        this.settings = res;

                        this.enableSetRestrictions =
                            this.settings
                                .allowBookingsOnlyAfterEndRespectiveQuarterlyAuctions ||
                            this.settings
                                .allowShippersToProvideAdditionalLabel ||
                            !this.settings
                                .allowCustomRuntimesForWithinDayBookings ||
                            this.settings.allowWithinDayFcfsBookings;

                        //if the portalUrl is undefined, then fcfs is implicit enabled
                        this.fcfsEnabled =
                            !this.settings.portalUrl ||
                            this.settings.portalUrl == '';

                        this.provideExternalFcfsUrl =
                            !!this.settings.portalUrl &&
                            this.settings.portalUrl !== '0' &&
                            this.settings.portalUrl !== '';
                        this.loadingSettings = false;
                    },
                    (err) => {
                        this.errorHandler(err);
                        this.loadingSettings = false;
                    }
                );
            }
        );
    }

    public saveAllowWithinDayFcfsBookings() {
        this.TransmissionSystemOperator.saveAllowWithinDayFcfsBookings(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowWithinDayFcfsBookings,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public saveAllowCustomRuntimesForWithinDayBookings() {
        this.TransmissionSystemOperator.saveAllowCustomRuntimesForWithinDayBookings(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowCustomRuntimesForWithinDayBookings,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public saveAllowShippersToProvideAdditionalLabel() {
        this.TransmissionSystemOperator.saveAllowShippersToProvideAdditionalLabel(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowShippersToProvideAdditionalLabel,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public saveAllowBookingsOnlyAfterEndRespectiveQuarterlyAuctions() {
        this.TransmissionSystemOperator.saveAllowBookingsOnlyAfterEndRespectiveQuarterlyAuctions(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowBookingsOnlyAfterEndRespectiveQuarterlyAuctions,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public saveReceiveCopyOfConfirmationEmail() {
        this.TransmissionSystemOperator.saveReceiveCopyOfConfirmationEmail(
            { id: this.authenticatedUser.referenceId },
            this.settings.receiveCopyOfConfirmationEmail,
            (res) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.settings.receiveCopyOfConfirmationEmail =
                    !this.settings.receiveCopyOfConfirmationEmail;
                this.errorHandler(err);
            }
        );
    }

    public saveFcfsStandardRuntimesOnly() {
        this.TransmissionSystemOperator.saveFcfsStandardRuntimesOnly(
            { id: this.authenticatedUser.referenceId },
            this.settings.fcfsStandardRuntimesOnly,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.settings.fcfsStandardRuntimesOnly =
                    !this.settings.fcfsStandardRuntimesOnly;
                this.errorHandler(err);
            }
        );
    }

    public saveFcfsStandardRuntimesOnlyNote() {
        return this.TransmissionSystemOperator.saveFcfsStandardRuntimesOnlyNote(
            { id: this.authenticatedUser.referenceId },
            this.settings.fcfsStandardRuntimesOnlyNote
        ).$promise;
    }

    public disableRestrictions() {
        if (!this.enableSetRestrictions) {
            this.togglingSetRestrictions = true;
            this.enableSetRestrictions = true;
            this.TransmissionSystemOperator.disableRestrictions(
                { id: this.authenticatedUser.referenceId },
                () => {
                    this.settings.allowWithinDayFcfsBookings = false;
                    this.settings.allowCustomRuntimesForWithinDayBookings =
                        true;
                    this.settings.allowShippersToProvideAdditionalLabel = false;
                    this.settings.allowBookingsOnlyAfterEndRespectiveQuarterlyAuctions =
                        false;
                    this.togglingSetRestrictions = false;
                    this.enableSetRestrictions = false;

                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                },
                this.errorHandler
            );
        }
    }

    public toggleFcfs() {
        if (this.togglingFcfs) {
            return;
        }
        this.fcfsEnabled = !this.fcfsEnabled;
        this.setConfirmDialogInformation();
        this.confirmModal(
            this.confirmDialogText,
            this.confirmDialogTitle
        ).result.then(() => {
            this.togglingFcfs = true;
            if (this.fcfsEnabled) {
                this.settings.portalUrl = '0';
                this.provideExternalFcfsUrl = false;
            } else {
                this.settings.portalUrl = '';
            }
            this.saveFcfsPortalUrl();
        });
    }

    public unToggle() {
        this.togglingFcfs = false;
    }

    public resetExternalUrl() {
        if (this.provideExternalFcfsUrl) {
            this.settings.portalUrl = '';
        } else {
            this.settings.portalUrl = '0';
            this.TransmissionSystemOperator.saveFcfsPortalUrl(
                { id: this.authenticatedUser.referenceId },
                { value: this.settings.portalUrl },
                () => {
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                },
                (err) => {
                    if (this.togglingFcfs) {
                        this.errorHandler(err);
                    }
                }
            );
        }
    }

    /**
     * fcfs cannot disabled/enabled explicit, it is implicit enabled when the portal URL is null/undefined
     *
     * so this method is used on the one hand to save the portal url and on the other hand to enable/disable FCFS
     */
    private saveFcfsPortalUrl(): ng.IPromise<any> {
        if (!this.fcfsEnabled && this.togglingFcfs) {
            this.currentFcfsPortalUrl = this.settings.portalUrl;
        }
        return this.TransmissionSystemOperator.saveFcfsPortalUrl(
            { id: this.authenticatedUser.referenceId },
            { value: this.settings.portalUrl },
            () => {
                if (this.togglingFcfs) {
                    this.fcfsEnabled = !this.fcfsEnabled;
                    this.unToggle();

                    if (!this.fcfsEnabled) {
                        this.disableFcfs();
                    } else {
                        this.enabledSettings.push('FCFS');
                    }
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                }
            },
            (err) => {
                if (this.togglingFcfs) {
                    this.unToggle();
                    this.errorHandler(err);
                }
                this.settings.portalUrl = this.currentFcfsPortalUrl;
            }
        ).$promise;
    }

    private disableFcfs() {
        //TODO: Reset lead time(s) and holiday calendars, when implement them
        this.settings.balancingGroupConfigLongTerm = 'NOT_APPLICABLE';
        this.settings.balancingGroupConfigShortTerm = 'NOT_APPLICABLE';
        this.settings.portfoliocodeConfigLongTerm = 'NOT_APPLICABLE';
        this.settings.portfoliocodeConfigShortTerm = 'NOT_APPLICABLE';
        this.settings.allowCustomRuntimesForWithinDayBookings = true;
        this.settings.allowShippersToProvideAdditionalLabel = false;
        this.settings.allowBookingsOnlyAfterEndRespectiveQuarterlyAuctions =
            false;
        this.settings.receiveCopyOfConfirmationEmail = false;
        this.enableSetRestrictions = false;

        if (this.enabledSettings.indexOf('FCFS') !== -1) {
            this.enabledSettings.splice(
                this.enabledSettings.indexOf('FCFS'),
                1
            );
        }
    }

    private setConfirmDialogInformation() {
        if (this.fcfsEnabled) {
            this.confirmDialogTitle =
                'Are you sure you want to disable this setting?';
            this.confirmDialogText =
                'By disabling it, you will also erase the current setting irreversibly';
        } else {
            this.confirmDialogTitle =
                'Are you sure you want to enable this setting?';
            this.confirmDialogText =
                'By enabling, the shippers will be able to book capacity via the FCFS booking process.';
        }
    }
}

angular.module('app').component('pkpOperatorSettingsFcfs', {
    controller: OperatorSettingsFcfsCtrl,
    template: require('app/operator-settings/operator-settings-fcfs.component.html'),
    bindings: {
        enabledSettings: '=',
        balancingGroupPortfolioCodeSelection: '<'
    }
});
